module.exports = __webpack_public_path__ + "static/media/restaurant-food2.5229aea3.jpeg";